import "../src/types/globalscope.ts";
// Depends on the ES6 Promise. That's why the es6-promise polyfill is bound to it by gulp

// Returns a promise of the file loaded
function loadJSFile(src): Promise<void> {
    return new Promise(function(resolve, ) {
        const element = document.createElement("script");
        element.src = src;
        // eslint-disable-next-line unicorn/prefer-add-event-listener
        element.onload = function() {
            resolve();
        };
        document.body.appendChild(element);
    });
};

// Usefull for building promise tree
window.curryLoadJSFile = function(src) {
    return function() { return loadJSFile(src); };
};

window.getDocumentLoadPromise = function() {
    return new Promise(function(resolve, ) {
        const pageLoaded = function() {
            resolve();
        };

        // Bind to the dom for the onload event.
        if (window.addEventListener)
            window.addEventListener("load", pageLoaded, false);
        // @ts-ignore ie function
        else if (window.attachEvent)
            // @ts-ignore
            window.attachEvent("onload", pageLoaded);
        else {
            // @ts-ignore
            // eslint-disable-next-line unicorn/prefer-add-event-listener
            window.onload = pageLoaded;
        }
    });
};





